// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3Bfw-","header":"MessagesList_header__36jd7","chat":"MessagesList_chat__1AdBN"};